<template>
    <b-button
        @click="() => { modalState = true }"
        size="sm"
        :variant="(httpRequestInProgress) ? 'success': 'primary'"
        :disabled="disabled"
        block
    ><!-- button -->
        {{modalTitle}}
        <b-modal
            v-model="modalState"
            centered
            size="md"
            :title="modalTitle"
        ><!-- modal -->
            <p>Diese Bestellung wirklich als Umbestellung markieren und neu bestellen?</p>
            <b class="p-2" v-if="lazyLoadingElements" >Passende Stocks werden gesucht...</b>
            <div class="d-flex justify-content-center">
                <b-overlay
                    id="overlay-coi-change-vendor-stocks"
                    :show="lazyLoadingElements || httpRequestInProgress"
                    variant="light"
                    opacity="0.5"
                    blur="2px"
                    rounded="lg"
                    style="min-height: 200px;"
                >
                    <!-- b-list-group>
                        <b-list-group-item v-for="stock in compiledStocks" :key="stock.id">
                            <b-checkbox v-model="stock.selected" @change="chooseStock(stock)" />
                            <span>{{stock.vendor.name}}(</span>
                            <span v-if="1 === stock.articleCondition">Neu</span>
                            <span v-else>SH</span>
                            <span> EK: {{stock.purchasePrice}}</span>
                            <span> Stock: {{stock.quantity}}</span>
                            <span v-if="21 === stock.vendorId">LZ: {{stock.vendorDeliveryTime}}</span>
                            <span>)</span>
                        </b-list-group-item>
                    </b-list-group -->
                    <b-form-radio-group id="radio-group-2"
                        name="radio-sub-component"
                        v-model="selectedStock"
                        :options="compiledStocks"
                        stacked
                    ></b-form-radio-group>

                </b-overlay>
            </div>
             <div slot="modal-footer" class="w-100">
               <b-button class="float-right mx-1"
                  centered
                  size="md"
                  variant="primary"
                  :disabled="!this.selectedStock"
                  @click="submit()"
               >umbestellen</b-button>
               <b-button
                  class="float-right"
                  size="md"
                  variant="secondary"
                  @click="() => { this.modalState = false; this.selectedStock = null }"
                >abbrechen</b-button>
            </div>
        </b-modal>
        <b-modal
            v-model="modalSuccessState"
            id="modal-success-dialog"
            title="Umbestellen"
            size="sm"
            centered
            @hidden="() => { this.modalState = false; this.userConsent = false }"
        ><!-- modal -->
            Erfolgreich umbestellt.
            <div slot="modal-footer" class="w-100">
               <b-button
                  centered
                  size="md"
                  class="float-right mx-1"
                  variant="success"
                  @click="() => {this.modalState = false; this.modalSuccessState = false }"
               >schliessen</b-button>
            </div>
        </b-modal>
    </b-button>
</template>
<script>
    export default {
        props: ['customerOrder', 'orderStates', 'authorization', 'vendors'],
        data() {
            return {
                stocks: null
              , selectedStock: null
              , modalState: false
              , modalSuccessState: false
              , httpRequestInProgress: false
              , lazyLoadingElements: false
            }
        },
        computed: {
            modalTitle: function() {
                if(this.authorization && this.authorization.dev)
                    return 'Umbestellung (VendorChange)';
                return 'Umbestellung';
            },
            disabled: function() {
                return this.orderStates.codes.OPEN !== this.customerOrder.orderState && this.orderStates.codes.NEW !== this.customerOrder.orderState;
            },
            compiledStocks: {
                get: function(n, o)
                {
                    if(!this.stocks) return [];
                    let opts = this.stocks.map( stock => {
                        if(stock.vendorId == 10000) return null;
                        stock.vendor = this.vendors.find( v => v.id == stock.vendorId );
                        stock.selected = false;
                        let text = stock.vendor.name;
                        text += `${(1 === stock.articleCondition) ? ' (Neu' : ' (SH'}`
                        //text += `, Eingangsporto: ${stock.vendorShippingFee}€, EK: ${stock.purchasePrice}€, Stock: ${stock.quantity}`;
                        text += `, EK+EP: ${stock.totalCost}€, Stock: ${stock.quantity}`;
                        if(21 == stock.vendorId) text += `, LZ:  ${stock.vendorDeliveryTime}`;
                        text += `, LK:  ${stock.vendor.deliveryClass})`;
                        return { value: stock.id, text };
                    }).filter( id => id );

                    opts.push({ text: 'Nachbestellung Amazon DE',       value: -1 });
                    opts.push({ text: 'Nachbestellung Amazon FR',       value: -2 });
                    opts.push({ text: 'Nachbestellung Amazon UK',       value: -3 });
                    opts.push({ text: 'Nachbestellung Amazon Ebay',     value: -4 });
                    opts.push({ text: 'Nachbestellung Amazon Sonstige', value: -5 });

                    return opts;
                }
            }


            /*
                crap: function() {
                    foreach($availableStocks as $availableStock){ //venor specific
                        if($availableStock->getVendorId() == 10000) continue;

                        $stockInformation = $availableStock->getVendor()->getName() . (($availableStock->getArticleCondition() == 1) ? ' (Neu' : ' (SH')
                        . " EK: "    . $availableStock->getPurchasePrice()
                        . " Stock: " . $availableStock->getQuantity()
                        . ( ($availableStock->getVendorId() == 21) ? ( " LZ: " . $availableStock->getVendorDeliveryTime() . ")" ) : ")");

                        $javascriptTemplate .= '<input type=\\\'radio\\\' name=\\\'newStockId\\\' value='.$availableStock->getId().' >'.$stockInformation.'<br />';

                    }
                    //marketplaces which also can be used as vendors so to say
                    if(!in_array($oldStock->getVendorId(), [99,199])) //Nachbestellung
                    {
                        $javascriptTemplate .= '<input type=\\\'radio\\\' name=\\\'newStockId\\\' value=-1 checked>Nachbestellung Amazon DE<br />';
                        $javascriptTemplate .= '<input type=\\\'radio\\\' name=\\\'newStockId\\\' value=-2 >Nachbestellung Amazon FR<br />';
                        $javascriptTemplate .= '<input type=\\\'radio\\\' name=\\\'newStockId\\\' value=-3 >Nachbestellung Amazon UK<br />';
                        $javascriptTemplate .= '<input type=\\\'radio\\\' name=\\\'newStockId\\\' value=-4 >Nachbestellung Ebay<br />';
                        $javascriptTemplate .= '<input type=\\\'radio\\\' name=\\\'newStockId\\\' value=-5 >Nachbestellung Sonstige<br />';
                    }

                        $javascriptTemplate = str_replace(array("\r\n","\n","\r"),'', $javascriptTemplate);
                        $javascriptTemplate = str_replace('   ','', $javascriptTemplate);
                    return '<br>'.$javascriptTemplate;
                },
            */

            // compiledStocks:{
            //     get: function(n, o){
            //         if(!this.stocks) return [];
            //         return this.stocks.map( s => {
            //             if(s.vendorId == 10000) return null;
            //             s.vendor = this.vendors.find( v => v.id == s.vendorId );
            //             s.selected = false;
            //             return s;
            //         }).filter( id => id );
            //     },
            //     set: function(newValue) {
            //         console.log(newValue.map( x => x.selected ).join( ', '));
            //     }
            // }

        },
        watch: {
            modalState: function(n, o) { if(n && !o) this.lazyLoad(); }
        },
        methods: {
            chooseStock(stock) {
                this.compiledStocks = this.compiledStocks.map( other => {
                    other.selected = (other.id == stock.id);
                    return other;
                });
            },
            lazyLoad() {
                this.httpRequestInProgress = true;
                this.lazyLoadingElements = true;
                Promise.all([
                    axios.post('customerorder/action/changevendor/fetchalternativevendors', { customerOrder: this.customerOrder }),
                    new Promise( resolve => setTimeout(resolve, 1200) )
                ])
                .then( ([response]) => {
                    this.stocks = response.data.map( function(stock) {
                            stock.vendorShippingFee = parseFloat(stock.vendorShippingFee); //.toFixed(2);
                            stock.purchasePrice = parseFloat(stock.purchasePrice)          //.toFixed(2);
                            stock.totalCost = stock.vendorShippingFee + stock.purchasePrice;
                            console.log(`totalCost: ${stock.totalCost}`);
                            stock.totalCost = `${stock.totalCost.toFixed(2)}`.replaceAll('.', ',');
                            //stock.vendorShippingFee.replaceAll('.', ',');
                            return stock;
                        }).sort( function(v, w) {
                            return (v.vendorShippingFee + v.purchasePrice)
                                 - (w.vendorShippingFee + w.purchasePrice);
                        });
                    this.httpRequestInProgress = false;
                    this.lazyLoadingElements = false;
                }).catch( error => {
                    alert("Konnte potentielle Stocks nicht abrufen: Server-Fehler.");
                    console.error(error);
                });
            },
            submit()
            {
                this.httpRequestInProgress = true;
                axios.post('/customerorder/action/changevendor', { customerOrderId: this.customerOrder.id, selectedStockId: this.selectedStock })
                .then( response => {
                    this.httpRequestInProgress = false;
                    this.modalSuccessState = true;
                    //either changevendor passes back a whole customerorder, or we need to still splice in the changed data.
                    this.$emit('mutatedStock', response.data);
                }).catch(error => {
                    alert("error");
                    console.error(error);
                });
            }
        }
    }
</script>
